import React, { Fragment } from "react"
import SpinnerImage from "../../common/SpinnerImage"
import FlowGraph from "../../dashboard/FlowGraph"

const FingerprintWidgetHeader = ({
    title,
    isFetching,
    noOfFingerprintItems,
}) => (
    <Fragment>
        <span className="icon icon-concepts" />
        {title}
        {(isFetching || noOfFingerprintItems !== undefined) && (
            <span className="widget-header-info">
                {isFetching ? (
                    <SpinnerImage isCentral={true} />
                ) : (
                    noOfFingerprintItems
                )}
            </span>
        )}
    </Fragment>
)

const InsightAreaFingerprintWidget = ({
    fingerprintFlow,
    title = "Fingerprint",
    isFetching,
    isEditMode = false,
    mappings,
    onRemoveItemClick,
}) => {
    if (
        !fingerprintFlow ||
        !fingerprintFlow.length ||
        !mappings ||
        !mappings.length
    ) {
        return null
    }
    return (
        <div id="fp">
            <FlowGraph
                isEditMode={isEditMode}
                flow={fingerprintFlow}
                highlightedItems={mappings}
                onRemoveItemClick={onRemoveItemClick}
                renderHeader={() => (
                    <FingerprintWidgetHeader
                        title={title}
                        isFetching={isFetching}
                        noOfFingerprintItems={fingerprintFlow.length}
                    />
                )}
            />
        </div>
    )
}

export default InsightAreaFingerprintWidget
